import rightImg from "images/about-hero-right.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionDowloadApp from "containers/PageHome/SectionDowloadApp";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>Sobre Nosotros - Turismo</title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      {/* <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg={rightImg}
          heading="👋 Sobre Nosotros."
          btnText=""
          subHeading="En Setia (Sindicato de Empleados Textiles de la Industria y Afines), somos una organización comprometida con la defensa y promoción de los derechos laborales de los trabajadores del sector textil en Argentina. Desde nuestra fundación, trabajamos arduamente para garantizar condiciones justas y equitativas en los ambientes de trabajo, fortaleciendo la representación sindical y apoyando a nuestros afiliados en cada aspecto de su desarrollo profesional.

Con una sólida trayectoria en la protección de los derechos laborales, Setia se ha consolidado como un referente en el ámbito sindical, priorizando siempre el bienestar de nuestros trabajadores. Nos dedicamos a mejorar la calidad de vida de los empleados del sector textil mediante la negociación colectiva, la capacitación continua y la implementación de programas de asistencia integral.

Nuestro compromiso es estar cerca de nuestros afiliados, escuchando sus necesidades y brindando soluciones concretas que los ayuden a enfrentar los desafíos actuales del sector. Juntos, seguimos trabajando para construir un futuro laboral más inclusivo, seguro y justo."
        /> */}

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <div
          className={`nc-SectionHero relative ${className}`}
          data-nc-id="SectionHero"
        >
          <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
            <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
              <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
                {"👋 Sobre Nosotros."}
              </h2>
              <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                {`En Setia (Sindicato de Empleados Textiles de la Industria y Afines), somos una organización comprometida con la defensa y promoción de los derechos laborales de los trabajadores del sector textil en Argentina. Desde nuestra fundación, trabajamos arduamente para garantizar condiciones justas y equitativas en los ambientes de trabajo, fortaleciendo la representación sindical y apoyando a nuestros afiliados en cada aspecto de su desarrollo profesional.

Con una sólida trayectoria en la protección de los derechos laborales, Setia se ha consolidado como un referente en el ámbito sindical, priorizando siempre el bienestar de nuestros trabajadores. Nos dedicamos a mejorar la calidad de vida de los empleados del sector textil mediante la negociación colectiva, la capacitación continua y la implementación de programas de asistencia integral.

Nuestro compromiso es estar cerca de nuestros afiliados, escuchando sus necesidades y brindando soluciones concretas que los ayuden a enfrentar los desafíos actuales del sector. Juntos, seguimos trabajando para construir un futuro laboral más inclusivo, seguro y justo.`}
              </span>
              
            </div>
            <div className="flex-grow lg:flex lg:justify-center ">
              <img className="w-full h-full lg:w-[400px] lg:h-[400px]" src={"https://i.ibb.co/551CrWq/ef282fff-3a3c-4354-b2c5-bc53cd2fa6a7.jpg"} alt="" />
            </div>
          </div>
        </div>
      


      {/* <SectionFounder />
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="PageAbout_" />
        </div> */}

      {/* <SectionStatistic /> */}

      {/* <SectionSubscribe2 /> */}
      
    </div>
    </div >
  );
};

export default PageAbout;
